import Review from '@/models/Review'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    reviewDetails: {
      user_trip_review_id: '',
      rating: '',
      review: '',
      user_avatar: null,
      photos: [],
      created_at: ''
    }
  },

  mutations: {
    setReviewList(state, reviews) {
      each(reviews, review => {
        const exist = find(state.list, { id: review.id })
        if (!exist) {
          state.list.push(new Review(review))
        }
      })
    },

    clearReviewList(state) {
      state.list = []
    },

    setReviewListMeta(state, meta) {
      state.listMeta = meta
    },

    setReviewDetails(state, review) {
      if (review instanceof Review) {
        state.reviewDetails = review
      } else {
        state.reviewDetails = new Review(review)
      }
    },

    clearReviewDetails(state) {
      state.reviewDetails = {
        user_trip_review_id: '',
        rating: '',
        review: '',
        user_avatar: null,
        photos: [],
        created_at: ''
      }
    }
  },

  actions: {
    async getReviews({ commit }, params) {
      const query = Review.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }
      if (params.date_reviewed) {
        query.where('date_reviewed', params.date_reviewed)
      }
      if (params.review_type) {
        query.where(params.review_type, 1)
      }
      if (params.comment_type) {
        query.where(params.comment_type, 1)
      }
      if (params.photo_type) {
        query.where(params.photo_type, 1)
      }
      if (params.user_type) {
        query.where(params.user_type, 1)
      }

      const res = await query
        .params({ limit: 20 })
        .include('photos')
        .get()

      commit('setReviewList', res.data)
      commit('setReviewListMeta', res.meta)
    },

    async getReviewDetails({ commit }, id) {
      const { data } = await Api.get(`admin/reviews/${id}`)
      commit('setReviewDetails', data.data)
    },

    async toggleHideTripReview({ commit }, id) {
      await Api.post(`admin/reviews/${id}/toggle-hide-review`)
    },

    async toggleHideReviewComment({ commit }, id) {
      const { data } = await Api.post(`admin/reviews/${id}/toggle-hide-comment`)
      commit('setReviewDetails', data.data)
    },

    async toggleHideReviewPhoto({ commit }, id) {
      await Api.post(`admin/reviews/${id}/toggle-hide-photo`)
    },

    async deleteReview({ commit }, id) {
      const { data } = await Api.delete(`admin/reviews/${id}`)
      commit('setReviewDetails', data.data)
    }
  }
}
